import React from "react";
import { default as MuiSnackbar } from "@mui/material/Snackbar";
import MuiButton from "@mui/material/Button";
import { default as MuiIconButton } from "@mui/material/IconButton";
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
const classes = {
    message: "snackbar-message"
};
export function Snackbar(props) {
    const alertType = props.alertType || "info";
    const autoHideDuration = 5000;
    const anchorOrigin = {
        vertical: "bottom",
        horizontal: "left"
    };
    let slideDirection = "left";
    if (props.direction) {
        switch (props.direction) {
            case "bottom-left":
                anchorOrigin.vertical = "bottom";
                anchorOrigin.horizontal = "left";
                slideDirection = "right";
                break;
            case "bottom-right":
                anchorOrigin.vertical = "bottom";
                anchorOrigin.horizontal = "right";
                slideDirection = "left";
                break;
            case "bottom-center":
                anchorOrigin.vertical = "bottom";
                anchorOrigin.horizontal = "center";
                slideDirection = "left";
                break;
            case "top-left":
                anchorOrigin.vertical = "top";
                anchorOrigin.horizontal = "left";
                slideDirection = "right";
                break;
            case "top-right":
                anchorOrigin.vertical = "top";
                anchorOrigin.horizontal = "right";
                slideDirection = "left";
                break;
        }
    }
    const actionElements = props.actions
        ? props.actions.map((action) => {
            return (React.createElement(MuiButton, { key: action.text, sx: { textDecoration: "underline" }, onClick: action.onClick, color: "inherit", size: "small" }, action.text));
        })
        : [];
    actionElements.push(React.createElement(MuiIconButton, { "aria-label": "close", size: "small", style: {
            color: "inherit"
        }, key: "snackbar-close", onClick: props.onClose },
        React.createElement(CloseIcon, null)));
    return (React.createElement(MuiSnackbar, { anchorOrigin: anchorOrigin, open: props.open, autoHideDuration: autoHideDuration, onClose: props.onClose, message: props.message },
        React.createElement(Alert, { classes: {
                message: classes.message
            }, variant: "filled", onClose: props.onClose, severity: alertType, action: React.createElement(React.Fragment, null, actionElements), sx: {
                borderRadius: "6px",
                [`& .${classes.message}`]: {
                    padding: "9px 0",
                    fontWeight: "bold"
                }
            } }, props.message)));
}
